import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Technologygcc = () => {
  return (
    <div className="tabing_section healthcare_tabs_sec cloud_computing_tabs p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h3 className="h3_head">
              Our Toolchain for <span>Performant Cloud Deployment</span>
            </h3>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
              As a leading cloud consulting company, we have the most
              sought-after and high-end tech stack to deliver optimized cloud
              deployments and comprehensive management solutions.
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Cloud Platforms">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/cloud_platforms/aws.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>AWS</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/cloud_platforms/azure.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Azure</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/cloud_platforms/google_cloud.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Google Cloud</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Configuration Management">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/config/ansible.webp"
                    alt="Ansible"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Ansible</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/config/chef.webp"
                    alt="Chef"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Chef</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/config/puppet.webp"
                    alt="Puppet"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Puppet</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Log Management">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/log/elastic_search.webp"
                    alt="Elasticsearch"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Elasticsearch</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/log/loggly.webp"
                    alt="Loggly"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Loggly</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/log/splunk.webp"
                    alt="Splunk"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Splunk</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Performance">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/performance/apache.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Apache</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/performance/firewall.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Firewall</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/performance/nginx.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>Nginx</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="Databases">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/database/mongoDB.webp"
                    alt="MongoDB"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>MongoDB</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/database/mySQL.webp"
                    alt="MySQL"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>MySQL</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/database/postgreSQL.webp"
                    alt="PostgreSQL"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={86}
                    height={86}
                  />
                  <div className="text_tabs_web">
                    <h6>PostgreSQL</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="6" title="Scripting Languages">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/language/bash_scripting.webp"
                    alt="Bash Scripting"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Bash Scripting</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/language/node_js.webp"
                    alt="Node js"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Node js</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/language/python.webp"
                    alt="Python"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Python</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="7" title="Source Code">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/source-code/git.webp"
                    alt="Git"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Git</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/source-code/github.webp"
                    alt="GitHub"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>GitHub</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/source-code/gitlab.webp"
                    alt="GitLab"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>GitLab</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="8" title="Build Automation">
              <ul>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/automation/Circle_CI.webp"
                    alt="CircleCl"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>CircleCI</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/automation/Travis_CI.webp"
                    alt="Travis"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Travis CI</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../images/services-usa/cloud-new/automation/jenkins.webp"
                    alt="Jenkins"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>Jenkins</h6>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
